import React from "react";
import { Reveal } from "../../lib/site";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative bg-navy py-24 md:py-36 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-4">
            <Reveal>
              <span className="text-xs md:text-sm uppercase tracking-[0.22em] font-semibold text-gold">
                01 — About Us
              </span>
              <p className="mt-6 text-sm text-slate-400 leading-relaxed max-w-xs">
                A global trading company built on relationships that last far beyond a single shipment.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <Reveal delay={1}>
              <h2 className="font-display font-light text-3xl md:text-5xl leading-[1.15] tracking-tight text-white text-balance">
                AM Ventures specializes in sourcing and supplying{" "}
                <span className="text-gold">quality products</span> across international markets —
                connecting trusted manufacturers with buyers worldwide.
              </h2>
            </Reveal>

            <div className="mt-14 grid sm:grid-cols-2 gap-x-12 gap-y-10">
              {[
                { t: "Integrity", d: "We do what we say. Honest dealing is the foundation of every partnership we form." },
                { t: "Transparency", d: "Clear pricing, open communication and full visibility across every stage of trade." },
                { t: "Quality Assurance", d: "Independent inspection and strict benchmarks ensure consistent, dependable products." },
                { t: "Long-Term Relationships", d: "We invest in partnerships that grow — for buyers and suppliers alike." },
              ].map((item, i) => (
                <Reveal key={item.t} delay={i}>
                  <div className="border-l border-white/10 pl-6">
                    <h3 className="font-display text-xl font-medium text-white">{item.t}</h3>
                    <p className="mt-2 text-slate-300 leading-relaxed text-[15px]">{item.d}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
